<div class="ticket-popup-container" *ngIf="notification">
  <div class="ticket-header">
    <div class="ticket-info">
      <i [class]="'pi ' + notification.iconClass"></i>
      <span *ngIf="notification.ticketNumberValue"
        >Ticket - {{ notification.ticketNumberValue }}</span
      >
      <span *ngIf="!notification.ticketIdValue">{{
        notification.notificationInstance?.Name
      }}</span>
    </div>
    <button class="close-button" (click)="onClose()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="ticket-content">
    <h2 class="ticket-subject">
      {{
        notification.fullTitle.replace(notification.ticketIdValue, "").trim()
      }}
    </h2>
    <p class="ticket-body">{{ notification.fullMessage }}</p>
  </div>

  <div class="ticket-footer">
    <div class="footer-column" *ngIf="createdOnField?.Value">
      <div class="field-label">{{ createdOnField?.Label }}</div>
      <div class="field-value">{{ createdOnField?.Value }}</div>
    </div>
    <div class="footer-column" *ngIf="createdByFullname">
      <div class="field-label">Created by</div>
      <div class="field-value">{{ createdByFullname }}</div>
    </div>
    <div class="footer-column" *ngIf="expiresOnField?.Value">
      <div class="field-label">{{ expiresOnField?.Label }}</div>
      <div class="field-value">{{ expiresOnField?.Value }}</div>
    </div>
    <div class="footer-column" *ngIf="createdByField?.Value">
      <div class="field-label">{{ createdByField?.Label }}</div>
      <div class="field-value">{{ createdByField?.Value }}</div>
    </div>
    <div
      class="footer-column"
      (click)="onOpenLink(detailsField.Value)"
      *ngIf="detailsField"
    >
      <div class="field-label">{{ detailsField?.Label }}</div>
      <div class="field-value">
        <a
          target="_blank"
          rel="noopener noreferrer"
          [href]="detailsField.Value"
          [pTooltip]="detailsField.Value"
          tooltipPosition="bottom"
        >
          {{ trimValue(detailsField.Value) }}
        </a>
      </div>
    </div>
    <div class="footer-column" *ngIf="locationField?.Value">
      <div class="field-label">{{ locationField?.Label }}</div>
      <div class="field-value">{{ locationField?.Value }}</div>
    </div>
    <div class="footer-column" *ngIf="statusField?.Value">
      <div class="field-label">{{ statusField?.Label }}</div>
      <div class="field-value">{{ statusField?.Value }}</div>
    </div>
  </div>

  <div class="actions">
    <button
      *ngIf="notification.ticketIdValue"
      class="view-conversation-btn"
      (click)="onViewConversationClick()"
    >
      View Conversation
    </button>
  </div>
</div>
